import axios from "axios";
import { config } from "../config";

export const deleteBusinessPhoto = async (
  businessId: string,
  url: string,
  token?: string
) => {
  return axios.delete(`${config.api.baseUrl}/business/${businessId}/photos`, {
    data: { url },
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
  });
};
